import type { ExpeditionSave } from './expedition';

/** Carry the checkpoint through reload even when browser storage is unavailable. */
export function expeditionHref(href: string, save: ExpeditionSave, persistent: boolean): string {
  const url = new URL(href);
  url.searchParams.set('mode', 'expedition');
  url.searchParams.set('seed', save.run.seed);
  url.searchParams.delete('level');
  if (persistent) url.searchParams.delete('expeditionState');
  else url.searchParams.set('expeditionState', JSON.stringify(save));
  return url.href;
}

export function campaignHref(href: string): string {
  const url = new URL(href);
  // Keep an unsaved profile in this tab's URL when returning to the campaign.
  url.searchParams.delete('seed');
  url.searchParams.set('mode', 'campaign');
  return url.href;
}
